document.addEventListener("touchmove", handler, {
    passive: !0
}), document.addEventListener("touchstart", function() {}, !1);
var loadJS = function(url, implementationCode, location) {
    var scriptTag = document.createElement("script");
    scriptTag.src = url, scriptTag.onload = implementationCode, scriptTag.onreadystatechange = implementationCode, location.appendChild(scriptTag)
};
$(window).on("load", function() {
    /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? ($("body").addClass("ios"), $(".header_nav li").on("click", function() {
        $(this).toggleClass("hover"), $(this).siblings("li").removeClass("hover")
    }), $(document).mouseup(function(e) {
        var container = $(".header_nav");
        !container.is(e.target) && container.has(e.target).length === 0 && $(".header_nav li").removeClass("hover")
    })) : $("body").addClass("web"), setTimeout(function() {
        $(".js-bg").each(function() {
            $(this).css("background-image", "url(" + $(this).data("preload") + ")")
        }), $(".js-img").each(function() {
            $(this).attr("src", $(this).data("src"))
        })
    }, 100), setTimeout(function() {
        $("body").removeClass("loaded")
    }, 100), $(".fancybox").length && $(".fancybox").fancybox({
        closeExisting: !0,
        touch: !1,
        smallBtn: !0,
        animationDuration: 300
    })
});

function viewport() {
    var e = window,
        a = "inner";
    return "innerWidth" in window || (a = "client", e = document.documentElement || document.body), {
        width: e[a + "Width"],
        height: e[a + "Height"]
    }
}
$(document).ready(function() {
    wow = new WOW({
        offset: 0
    }), wow.init()
}), $(function() {
    $(".form-control").each(function() {
        var placeholder = $(this).attr("placeholder");
        $(this).focus(function() {
            $(this).attr("placeholder", "")
        }), $(this).focusout(function() {
            $(this).attr("placeholder", placeholder)
        })
    }), $(".header_opener").on("click", function() {
        return $(".header").toggleClass("open"), $("html").toggleClass("noscroll-tablet"), $(this).toggleClass("active"), !1
    }), $(".js-local").on("click", function() {
        var target = $(this).attr("href");
        return $("html, body").animate({
            scrollTop: $(target).offset().top
        }, 750), !1
    });

    function showDiv() {
        $(window).scrollTop() > 200 && $(".header").data("positioned") == "false" ? ($(".header").data("positioned", "true"), $(".header").addClass("fix")) : $(window).scrollTop() <= 200 && $(".header").data("positioned") == "true" && $(".header").fadeIn(0, function() {
            $(".header").removeClass("fix")
        }).data("positioned", "false")
    }
    $(window).scroll(showDiv), $(".header").data("positioned", "false");
    const swiperServices = new Swiper(".js-services_slider", {
            loop: !1,
            spaceBetween: 15,
            slidesPerView: "auto",
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            scrollbar: {
                el: ".swiper-scrollbar",
                draggable: !0
            },
            breakpoints: {
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 20
                }
            }
        }),
        swiperStudios = new Swiper(".js-studios_slider", {
            loop: !0,
            slidesPerView: 1,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            }
        }),
        swiperCustomers = new Swiper(".js-customers_slider", {
            loop: !0,
            spaceBetween: 18,
            centeredSlides: !0,
            slidesPerView: "auto",
            slidesPerGroup: 1,
            slidesOffsetAfter: 0,
            breakpoints: {
                520: {
                    slidesPerView: 2,
                    centeredSlides: !1,
                    spaceBetween: 25
                },
                768: {
                    slidesPerView: 3,
                    centeredSlides: !1,
                    spaceBetween: 25
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 25,
                    centeredSlides: !1
                },
                1441: {
                    slidesPerView: 5,
                    spaceBetween: 25,
                    centeredSlides: !1
                },
                1660: {
                    slidesPerView: 6,
                    spaceBetween: 25,
                    centeredSlides: !1
                }
            },
            autoplay: {
                delay: 2500,
                disableOnInteraction: !1
            }
        });
    $(".faq_list_q").on("click", function() {
        return $(this).parent("").toggleClass("open"), $(this).next("").slideToggle(400), !1
    }), $(".form_anim .form-control").each(function() {
        $(this).val() == "" ? $(this).parent(".form_anim").removeClass("filled") : $(this).parent(".form_anim").addClass("filled")
    }), $(".form_anim .form-control").focus(function() {
        $(this).parent(".form_anim").addClass("filled")
    }), $(".form_anim .form-control").on("input", function() {
        $(this).parent(".form_anim").addClass("filled")
    }), $(".form_anim .form-control").blur(function() {
        $(this).val() == "" && $(this).parent(".form_anim").removeClass("filled")
    });
    const swiperInner = new Swiper(".js-inner_slider", {
            loop: !1,
            spaceBetween: 31,
            slidesPerView: "auto",
            centeredSlides: !0,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            scrollbar: {
                el: ".swiper-scrollbar",
                draggable: !0
            },
            breakpoints: {
                1024: {
                    slidesPerView: "auto",
                    spaceBetween: 73
                }
            }
        }),
        swiperSteps = new Swiper(".js-about-steps_slider", {
            loop: !1,
            spaceBetween: 16,
            slidesPerView: "auto",
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            scrollbar: {
                el: ".swiper-scrollbar",
                draggable: !0
            },
            breakpoints: {
                1024: {
                    slidesPerView: "auto",
                    spaceBetween: 22
                }
            }
        });
    if ($("#map").length) {
        let init2 = function() {
            var mapOptions = {
                    zoom: 15,
                    scrollwheel: !1,
                    disableDefaultUI: !0,
                    center: new google.maps.LatLng(55.85885847260101, 37.35337764283753)
                },
                mapElement = document.getElementById("map"),
                map = new google.maps.Map(mapElement, mapOptions),
                mapElement2 = document.getElementById("map2"),
                map2 = new google.maps.Map(mapElement2, mapOptions)
        };
        var init = init2;
        setTimeout(function() {
            google.maps.event.addDomListener(window, "load", init2), init2()
        }, 500)
    }
    $("#form").length && ($("#form").validate({
        rules: {
            name: {
                required: !0
            },
            tel: {
                required: !0,
                digits: !0,
                minlength: 10
            },
            location: {
                required: !0
            },
            goal: {
                required: !0
            },
            messagetxt: {
                required: !0
            },
            check: {
                required: !0
            }
        },
        messages: {
            name: "This field is required",
            tel: {
                required: "This field is required",
                digits: "Please enter a valid phone number",
                minlength: "Phone number must be at least 10 digits"
            },
            location: "Please select a location",
            goal: "Please select a goal",
            messagetxt: "This field is required",
            check: "This field is required"
        }
        // submitHandler: function(form) {
        //     var f = $(form),
        //         name = $('input[name="name"]', f).val(),
        //         tel = $('input[name="tel"]', f).val(),
        //         location = $('select[name="location"]', f).val(),
        //         goal = $('select[name="goal"]', f).val();
        //     fetch("/config.php").then(response => response.json()).then(keys => {
        //         const emailPublicApiKey = keys.emailPublicKey,
        //             emailServiceApiKey = keys.emailServiceKey,
        //             emailTemplateApiKey = keys.emailTemplateKey;
        //         var data = {
        //             service_id: emailServiceApiKey,
        //             template_id: emailTemplateApiKey,
        //             user_id: emailPublicApiKey,
        //             template_params: {
        //                 name,
        //                 tel,
        //                 location,
        //                 goal
        //             }
        //         };
        //         return $.ajax("https://api.emailjs.com/api/v1.0/email/send", {
        //             type: "POST",
        //             data: JSON.stringify(data),
        //             contentType: "application/json"
        //         })
        //     }).then(() => {
        //         setTimeout(function() {
        //         window.location.href = "/pages/thankyou"
        //         }, 100)
        //     }).catch(error => {
        //         // console.error("Error:", error), alert("Failed to send the email.")
        //     }), setTimeout(function() {
        //         $(form).trigger("reset")
        //     }, 1e3)
        // }
    }), $("#form").on("submit", function(e) {
        if (e.preventDefault(), !$("#form").valid()) return alert("Please fill out all required fields before submitting."), !1
    })), $(".js-anchor").on("click", function() {
        if ($($(this).attr("href")).length) {
            var $offset = $($(this).attr("href")).offset().top - $(".header").height();
            $("html, body").animate({
                scrollTop: $offset
            }, 500)
        }
    })
}), document.addEventListener("DOMContentLoaded", function() {});
var handler = function() {
    var height_footer = $(".footer").height(),
        height_header = $(".header").height(),
        viewport_wid = viewport().width,
        viewport_height = viewport().height;
    $(".js-vh").css({
        height: $(window).height()
    }), viewport_wid <= 991 || viewport_wid > 991
};
$(window).bind("load", handler), $(window).bind("resize", handler);
//# sourceMappingURL=/s/files/1/0777/2795/7220/files/custom.js.map?v=1763969202